<template>
  <div>
    <v-card v-if="data">
      <v-card-title class="text_primary pb-0">
        容器資訊

        <v-spacer></v-spacer>

        <v-btn v-if="!is_edit" class="text_default btn_default btn_default_bg_linear" outlined @click="startEdit">
          編輯
        </v-btn>

        <v-btn v-if="is_edit" class="text_default btn_default btn_default_bg_linear mr-3" outlined @click="cancelEdit">
          取消
        </v-btn>

        <v-btn v-if="is_edit" class="btn-primary" outlined @click="saveEdit"> 保存 </v-btn>
      </v-card-title>

      <v-form ref="form">
        <!-- 系統欄位的區塊 -->
        <v-card-title class="text_primary pb-2">
          {{ container_info.name }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="10" md="8" lg="4">
              <div v-for="(block_setting_field, idx) in container_info.fields" :key="idx">
                <h5 class="mb-1 pb-0 form-label">
                  {{ block_setting_field.title }}
                  <span v-if="block_setting_field.is_required" class="required-hint">(必填)</span>
                </h5>

                <template v-if="block_setting_field.editable === true">
                  <v-text-field
                    v-if="block_setting_field.type === 'text'"
                    v-model="block_setting_field.value"
                    type="text"
                    outlined
                    dense
                    height="12"
                    :rules="block_setting_field.rules"
                    :disabled="!is_edit"
                  >
                  </v-text-field>
                </template>

                <template v-else>
                  <div class="mb-2">{{ block_setting_field.value }}</div>
                </template>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-text v-if="quota_info[$route.params.org_id].level === 'nineder'">
          <v-form ref="token_form" lazy-validation @submit.prevent>
            <v-card-title class="text_primary pb-2 pl-0"> 權杖令牌 </v-card-title>

            <div v-for="(edit_token, idx) in edit_tokens" :key="idx">
              <v-row v-if="edit_token.status !== 'delete'">
                <v-col cols="5" lg="5" md="5" class="pb-0">
                  <h5 class="pb-0">
                    名稱
                    <span class="required-hint pl-2">(必填)</span>
                  </h5>
                  <v-text-field
                    v-model="edit_token.name"
                    type="text"
                    outlined
                    dense
                    height="12"
                    placeholder="Facebook CAPI Token"
                    :rules="[$utils.field_rules.required]"
                    :disabled="!is_edit"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="5" lg="5" md="5" class="pb-0">
                  <h5 class="pb-0">Token<span class="required-hint pl-2">(必填)</span></h5>
                  <v-text-field
                    v-model="edit_token.secret_token"
                    type="text"
                    outlined
                    dense
                    height="12"
                    placeholder="從第三方平台複製的令牌"
                    required
                    :rules="[
                      $utils.field_rules.required,
                      $utils.field_rules.biggerThanLen(edit_token.secret_token, 10),
                    ]"
                    :disabled="!is_edit"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2" lg="2" md="2" class="d-flex align-center">
                  <v-btn icon dense :disabled="!is_edit" color="error" outlined @click="removeToken(edit_token, idx)">
                    <v-icon> mdi-close </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <div class="mt-3">
              <v-btn color="primary" :disabled="!is_edit" @click="addToken"> 新增 </v-btn>
            </div>
          </v-form>
        </v-card-text>

        <!-- add_column的區塊 -->
        <template v-for="(category, category_key) in category_fields">
          <div :key="category_key">
            <v-card-title class="text_primary pb-0">
              {{ category.name }}
            </v-card-title>
            <div v-for="(sub_category, sub_category_key) in category.sub_category" :key="sub_category_key">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="10" md="8" lg="12">
                    <template v-for="(setting_field, idx) in sub_category.fields">
                      <div
                        v-if="
                          !setting_field.show_levels ||
                          setting_field.show_levels.includes(quota_info[$route.params.org_id].level)
                        "
                        :key="`${idx}`"
                      >
                        <h5 class="mb-1 pb-0 d-flex form-label">
                          <span>{{ setting_field.title }}</span>
                          <v-icon
                            v-if="hint[setting_field.id]"
                            class="ml-1"
                            small
                            color="primary"
                            @click="showHint(hint[setting_field.id])"
                          >
                            mdi-help-circle
                          </v-icon>
                        </h5>
                        <v-text-field
                          v-if="setting_field.type === 'text'"
                          v-model="setting_field.value"
                          type="text"
                          outlined
                          dense
                          height="12"
                          :disabled="!is_edit"
                        >
                        </v-text-field>
                      </div>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
            <v-divider :key="category_key + '_d'"></v-divider>
          </div>
        </template>
      </v-form>

      <v-card-text>
        <v-card-title class="text_primary pb-2 pl-0">
          綁定 LINE 通知
          <v-icon class="ml-1" small color="primary" @click="showHint(line_bind_hint)"> mdi-help-circle </v-icon>
        </v-card-title>
        <v-row no-gutters>
          <v-col cols="12" sm="10" md="8" lg="12">
            <template v-if="notify.id">
              <label class="mb-1 form-label" v-text="'群組名稱'" />
              <p v-text="notify.group_name" />
            </template>
            <template v-else>
              <label class="mb-1 form-label" v-text="'Token'" />
              <v-text-field
                v-model="notify.token"
                class="mb-3"
                type="text"
                outlined
                dense
                height="12"
                placeholder="請輸入從Line拿到的Token，例如: 36f1a7f9d1285704680293cd80a551b"
                hide-details
              />
            </template>
          </v-col>
          <v-col cols="12">
            <v-btn
              v-if="notify.id"
              color="error"
              @click="
                confirmDialogController({
                  title: '解除綁定',
                  content: '確定要解除綁定嗎？',
                  sure: unbindNotifyGroup,
                  cancel: confirmDialogController,
                })
              "
              v-text="'解除綁定'"
            />
            <v-btn v-else color="primary" @click="createOrUpdateNotifyGroup()" v-text="'綁定 TOKEN'" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="hint_dialog.is_show" width="650">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ hint_dialog.title }}
        </v-card-title>

        <v-card-text v-if="hint_dialog.component" class="mt-6">
          <component :is="hint_dialog.component" :alert_type="hint_dialog.alert_type" :message="hint_dialog.message">
          </component>
        </v-card-text>

        <v-card-text v-else class="mt-6">
          <div class="d-flex align-center flex-column" v-html="hint_dialog.html"></div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="hideHint"> 關閉 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 二次確認 Dialog 統一用這個 -->
    <v-dialog v-model="confirm_dialog.status" max-width="600">
      <v-card>
        <v-card-title class="error white--text" v-text="confirm_dialog.title" />
        <v-card-text class="pt-5" v-text="confirm_dialog.content" />
        <v-card-actions class="justify-space-between">
          <v-btn @click="confirm_dialog.cancel()" v-text="'取消'" />
          <v-btn color="error" @click="confirm_dialog.sure()" v-text="'確定'" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { apiUpdateContainer, apiGetContainer } from '@/api/optimize.js'
import { apiCreateOrUpdateNotifyGroup, apiGetNotifyInfo, apiUnbindNotifyGroup } from '@/api/notify.js'
import { apiCreateContainerToken, apiUpdateContainerToken, apiDeleteContainerToken } from '@/api/container.js'
export default {
  name: 'ContainerEdit',
  data() {
    return {
      rm_tokens: [],
      edit_tokens: [],
      rules: this.$utils.field_rules,
      data: null,
      is_edit: false,
      hint_dialog: {
        is_show: false,
        title: '',
        html: '',
      },
      hint: {
        ga_id: {
          title: '在哪裡尋找我的Google Analytics編號?',
          html: `
                  <p>登入Google Google Analytics後，點擊左上角的選單找到Google Analytics編號，如下圖所示</p>
                  <img style="width:100%;" src="/example/ga_id_example.png" />
                `,
        },
      },
      category_fields: {
        optimize: {
          name: '頁面優化',
          sub_category: {
            experiment: {
              name: '實驗',
              fields: {
                ga_id: {
                  info: 'ga_id',
                  title: 'Google Analytics編號',
                  id: 'ga_id',
                  value: '',
                  copy: '',
                  editable: true,
                  type: 'text',
                  is_required: false,
                },
              },
            },
          },
        },
        else: {
          name: '其他設定',
          sub_category: {
            else: {
              name: '其他',
              fields: {
                backend_prefix: {
                  info: 'backend_prefix',
                  title: '後台連結',
                  id: 'backend_prefix',
                  value: '',
                  copy: '',
                  editable: true,
                  type: 'text',
                  is_required: false,
                },
                clarity_prefix: {
                  info: 'clarity_prefix',
                  title: 'Clarity連結',
                  id: 'clarity_prefix',
                  value: '',
                  copy: '',
                  editable: true,
                  type: 'text',
                  is_required: false,
                  show_levels: ['nineder'],
                },
              },
            },
          },
        },
      },
      container_info: {
        name: '',
        fields: [
          {
            title: 'ID',
            id: 'id',
            value: '',
            copy: '',
            editable: false,
            type: 'text',
            is_required: false,
            rules: [],
            is_disaplay: true,
          },
          {
            title: '名稱',
            id: 'name',
            value: '',
            copy: '',
            editable: true,
            type: 'text',
            is_required: true,
            rules: [this.$utils.field_rules.required],
            is_disaplay: true,
          },
          {
            title: '網站',
            id: 'domain',
            value: '',
            copy: '',
            editable: true,
            type: 'text',
            is_required: true,
            rules: [this.$utils.field_rules.required],
            is_disaplay: true,
          },
        ],
      },
      notify: {
        id: 0,
        token: '',
        group_name: '',
      },
      confirm_dialog: {
        status: false,
        title: '',
        content: '',
        cancel: null,
        sure: null,
      },
      line_bind_hint: {},
    }
  },
  computed: {
    quota_info() {
      return this.$store.getters.memberQuota
    },
  },
  async created() {
    try {
      await this.getContainerData()

      // 設定麵包屑顯示選擇的人！
      this.$store.commit('update_breadcrumbs', [
        {
          text: '設定',
          disabled: true,
        },
        {
          text: '容器',
          disabled: false,
          href: `/${this.$route.params.org_id}/setting/containers/`,
        },
        {
          text: this.data.name,
        },
      ])

      console.log('data', this.data)
    } catch (error) {
      this.$root.vtoast.show({
        message: '編輯容器失敗，原因: ' + error,
      })
      console.log('error', error)
    }

    this.getNotifyInfo()
    let example_key = 'pro'
    if (process.env.VUE_APP_MODE !== 'production') {
      example_key = 'staging'
    }
    this.line_bind_hint = {
      title: '加入Optimize99 LINE 官方帳號',
      html: `
        <p>打開LINE，掃描QR Code進行綁定！</p>
        <img style="width:80%;" src="/example/line-qrcode-${example_key}.png" />
      `,
    }
  },
  methods: {
    startEdit: function () {
      let that = this
      this.is_edit = true
      this.container_info.fields.forEach((block_setting_field) => {
        block_setting_field.copy = block_setting_field.value
      })
      let categorys = Object.keys(this.category_fields)
      categorys.forEach(function (category) {
        let sub_categorys = Object.keys(that.category_fields[category].sub_category)
        sub_categorys.forEach(function (sub_category) {
          console.log(category, sub_category)
          let feature_fields = Object.keys(that.category_fields[category]['sub_category'][sub_category].fields)
          feature_fields.forEach(function (feature_field) {
            that.category_fields[category]['sub_category'][sub_category].fields[feature_field].copy =
              that.category_fields[category]['sub_category'][sub_category].fields[feature_field].value
          })
        })
      })
    },
    cancelEdit: async function () {
      this.is_edit = false
      await this.getContainerData()
    },
    async saveEdit() {
      try {
        let that = this
        let form_valid = this.$refs.form.validate()
        let token_form = this.$refs.token_form.validate()
        console.log('form_valid:', form_valid)

        if (form_valid === false || token_form === false) {
          this.$root.vtoast.show({
            message: '請將必填欄位填寫完畢。',
          })
          return
        }

        let params = {}
        this.container_info.fields.forEach((field) => {
          params[field.id] = field.value
        })

        let add_column = {}
        let categorys = Object.keys(this.category_fields)
        categorys.forEach(function (category) {
          add_column[category] = {}
          let sub_categorys = Object.keys(that.category_fields[category].sub_category)
          sub_categorys.forEach(function (sub_category) {
            if (sub_category !== 'name') {
              add_column[category][sub_category] = that.category_fields[category]['sub_category'][sub_category].fields
            }
          })
        })
        params['add_column'] = JSON.stringify(add_column)
        await apiUpdateContainer(params, this.data.id, this.data.org_id)
      } catch (error) {
        this.$root.vtoast.show({
          message: '更新容器失敗，原因: ' + error,
        })
      }

      try {
        let create_tokens = this.edit_tokens.filter((edit_token) => {
          return edit_token.id.toString().includes('t-')
        })
        let update_tokens = this.edit_tokens.filter((edit_token) => {
          let result = this.data.secret_tokens.find((secret_token) => {
            return secret_token.id === edit_token.id && secret_token.token_display !== edit_token.secret_token
          })
          if (result) {
            return edit_token
          }
        })
        let delete_tokens = this.rm_tokens.filter((edit_token) => {
          return edit_token.id.toString().includes('t-') === false
        })

        for (let idx = 0; idx < create_tokens.length; idx++) {
          try {
            let tmp = JSON.parse(JSON.stringify(create_tokens[idx]))
            delete tmp.id
            let result = await apiCreateContainerToken(this.$route.params.org_id, tmp)
            console.log('c_r', result)
          } catch (error) {
            this.$root.vtoast.show({
              message: `新增token失敗，原因: ${error}`,
            })
          }
        }

        for (let idx = 0; idx < update_tokens.length; idx++) {
          try {
            let tmp = JSON.parse(JSON.stringify(update_tokens[idx]))
            let result = await apiUpdateContainerToken(this.$route.params.org_id, tmp)
            console.log('u_r', result)
          } catch (error) {
            this.$root.vtoast.show({
              message: `更新token失敗，原因: ${error}`,
            })
          }
        }

        for (let idx = 0; idx < delete_tokens.length; idx++) {
          try {
            let result = await apiDeleteContainerToken(this.$route.params.org_id, delete_tokens[idx].id)
            console.log('d_r', result)
          } catch (error) {
            this.$root.vtoast.show({
              message: `刪除token失敗，原因: ${error}`,
            })
          }
        }
        console.log(create_tokens)
        console.log(update_tokens)
        console.log(delete_tokens)
      } catch (error) {
        console.log('error', error)
      }

      this.is_edit = false
      this.$root.vtoast.show({
        color: 'primary',
        message: '保存成功！',
      })

      await this.getContainerData()
    },
    showHint(hint_setting) {
      this.hint_dialog.title = hint_setting.title
      this.hint_dialog.html = hint_setting.html
      this.hint_dialog.is_show = true
    },
    hideHint() {
      this.hint_dialog.is_show = false
    },
    async getContainerData() {
      let that = this
      let container_id = this.$route.params.container_id
      console.log('current_container_id', container_id)
      if (!container_id) {
        this.$router.push(`/${this.$route.params.org_id}/setting/containers/`)
      }

      let container = await apiGetContainer(this.$route.params.org_id, container_id)

      console.log('container', container)

      if (container.data.length === 0) {
        this.$router.push(`/${this.$route.params.org_id}/setting/containers/`)
      }

      let selected_container = container.data
      this.data = selected_container
      console.log('this.data', this.data)

      this.container_info.fields.forEach((block_setting_field) => {
        if (that.data[block_setting_field.id]) {
          block_setting_field.value = that.data[block_setting_field.id]
        }
      })

      if (this.data.add_column === null) {
        this.data.add_column = {}
      } else {
        this.data.add_column = JSON.parse(this.data.add_column)
      }

      let categorys = Object.keys(this.category_fields)
      categorys.forEach(function (category) {
        if (!that.data.add_column[category]) {
          that.data.add_column[category] = {}
        }
        let sub_categorys = Object.keys(that.category_fields[category].sub_category)
        sub_categorys.forEach(function (sub_category) {
          console.log('sub_category: ', that.category_fields[category]['sub_category'][sub_category])
          if (sub_category !== 'name') {
            if (that.data.add_column[category][sub_category]) {
              that.category_fields[category]['sub_category'][sub_category].fields =
                that.data.add_column[category][sub_category]
            }
          }
        })
      })

      let secret_tokens = JSON.parse(JSON.stringify(this.data.secret_tokens))
      this.edit_tokens = secret_tokens.map((secret_token) => {
        return {
          id: secret_token.id,
          name: secret_token.token_name,
          secret_token: secret_token.token_display,
        }
      })
      console.log('this.edit_token', this.edit_tokens)
    },
    addToken() {
      console.log('add_token')
      let tmp_token = {
        container_id: this.$route.params.container_id,
        id: `t-${new Date().getTime()}`,
        secret_token: '',
      }
      this.edit_tokens.push(tmp_token)
    },
    removeToken(token, idx) {
      console.log('rm_token', token)
      this.rm_tokens.push(token)
      this.edit_tokens.splice(idx, 1)
    },
    async getNotifyInfo() {
      try {
        const params = {
          container_id: this.$route.params.container_id,
          org: this.$route.params.org_id,
        }
        const res = await apiGetNotifyInfo(params)
        if (res.length) {
          res.forEach((item) => {
            this.notify.id = item.id
            this.notify.group_name = item.receiver_name
          })
        }
      } catch (error) {
        console.error('get error :', error)
      }
    },
    async createOrUpdateNotifyGroup() {
      try {
        const params = {
          org: this.$route.params.org_id,
        }
        const payload = {
          notify_platform: 'linebot',
          container_id: this.$route.params.container_id,
          token: this.notify.token,
        }

        await apiCreateOrUpdateNotifyGroup(params, payload)
        this.getNotifyInfo()
      } catch (error) {
        console.error('createOrUpdateNotifyGroup error:', error)
        this.$root.vtoast.show({
          message: '綁定失敗',
          color: 'error',
        })
      }
    },
    async unbindNotifyGroup() {
      try {
        const params = {
          id: this.notify.id,
          org: this.$route.params.org_id,
        }
        await apiUnbindNotifyGroup(params)
        //init
        this.notify = {
          id: 0,
          group_name: '',
          token: '',
        }
      } catch (error) {
        console.error('unbindNotifyGroup error :', error)
        this.$root.vtoast.show({
          message: '解除綁定失敗',
          color: 'error',
        })
      } finally {
        this.confirmDialogController()
      }
    },
    confirmDialogController(data) {
      if (this.confirm_dialog.status) {
        this.confirm_dialog.status = false
        return
      }
      this.confirm_dialog = {
        status: true,
        title: data.title,
        content: data.content,
        cancel: data.cancel,
        sure: data.sure,
      }
    },
  },
}
</script>

<style scoped>
.required-hint {
  color: #ee3333;
}
.form-label {
  color: #393e48;
  font-weight: 500;
  font-size: 16px;
}
</style>
